import React, { useEffect, useState, useContext } from 'react'
import mainContext from '../../contexts/mainContext'
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import { getUserPaymentList, markPaymentAsPaid } from '../../Controllers/Payments';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Pagination, styled } from '@mui/material';
import moment from 'moment';
import SearchBar from './SearchBar';
import PaymentDetails from './PaymentDetails';
import CheckBox from '@mui/material/Checkbox';
let payableAmount = 0

export default function UserPayments() {
    const { setSnackBar, setProfileNavTitle, setPageload } = useContext(mainContext);
    const [state, setState] = useState({ payment: [], total: 0 })
    const [filterState, setFilterState] = React.useState({});
    const [paymentInfo, setPaymentInfo] = React.useState({ id: 0, data: {}, open: false })
    const [selectedPayment, setSelectedPayment] = React.useState({ ids: [], openModal: false })

    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    useEffect(() => {
        // const userId = new URLSearchParams(window.location.search).get('userId')
        setProfileNavTitle("Payments & Earnings");
        fetchPayments(1)
    }, [])

    const fetchPayments = async (page, isClear) => { /* Handling api call */
        setPageload(true)
        let params = { page }
        if (!isClear) {
            let urlParam = new URLSearchParams(window.location.search)
            if (urlParam.get('userId') && ["HouseKeeper", "BabySitter"].includes(urlParam.get('role'))) {
                setFilterState({ ...filterState, provider: urlParam.get('role'), userIds: urlParam.get('userId'), isApplied: true })
                params = { page, ...filterState, userIds: urlParam.get('userId') }
            }
            else {
                params = { page, ...filterState }
            }

        }
        else
            setSelectedPayment({ ...selectedPayment, ids: [], openModal: false })
        const res = await getUserPaymentList(params)
        setPageload(false)
        if (res.data.status === 200) {
            setState({ ...state, ...res.data.data })
        } else {
            callSnackBar(res.data.errors[0].message, "error")
        }
    }

    const handleCheck = (id, data) => {
        if (!filterState.userIds) {
            return alert("Please select provider")
        }
        else if (!filterState.isApplied) {
            return alert("Please select provider and apply filter.")

        }
        let temp = [...selectedPayment.ids]
        let ind = temp.indexOf(id)
        if (ind !== -1) {
            temp.splice(ind, 1)
            data.paymentInfo.type === "AdvanceFee" ?
                payableAmount = payableAmount - data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.depositAmount :
                payableAmount = payableAmount - data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.payableAmount + data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.meta?.tip - data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.meta?.extraCharges
        }
        else {
            temp.push(id)
            data.paymentInfo.type === "AdvanceFee" ?
                payableAmount = payableAmount + data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.depositAmount :
                payableAmount = payableAmount + data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.payableAmount
        }
        setSelectedPayment({ ...selectedPayment, ids: temp })
    }

    const handleAllCheck = () => {
        if (!filterState.userIds) {
            return alert("Please select provider")
        }
        else if (!filterState.isApplied) {
            return alert("Please select provider and apply filter.")

        }

        let temp = []
        payableAmount = 0
        if (selectedPayment.ids.length !== checkAllStatusCount()) {
            state.payment.forEach(data => {
                if (data?.paidInfo?.status === "Unpaid") { /* Insert only unpaid payouts */
                    temp.push(data._id)
                    data.paymentInfo.type === "AdvanceFee" ?
                        payableAmount = payableAmount + data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.depositAmount :
                        payableAmount = payableAmount + data?.invoiceInfo[0]?.invoiceInfo?.billDetail?.providerView?.payableAmount
                }
            })
        }
        setSelectedPayment({ ...selectedPayment, ids: temp })
    }

    const checkAllStatusCount = () => {
        let count = null
        state.payment.forEach(data => {
            if (data?.paidInfo?.status === "Unpaid") { /* Insert only unpaid payouts */
                count++;
            }
        })
        return count
    }

    return (
        <>
            <SearchBar placeholder={"Enter job no"} filterState={filterState} setFilterState={setFilterState} callFunction={fetchPayments} />
            <PaymentDetails paymentInfo={paymentInfo} setPaymentInfo={setPaymentInfo} />

            {selectedPayment.openModal && <MakePayment
                open={selectedPayment.openModal}
                handleClose={() => setSelectedPayment({ ...selectedPayment, openModal: false })}
                paymentIds={selectedPayment.ids}
                amount={payableAmount}
                providerId={filterState.userIds}
                userInfo={filterState.userInfo}
                onUpdate={() => { fetchPayments(1); setSelectedPayment({ ...selectedPayment, openModal: false, ids: [] }) }}
            />}
            <Container className='scrollbar'>
                {selectedPayment.ids.length !== 0 && filterState.userIds && filterState.isApplied &&
                    <div>
                        <div style={{ marginBottom: '5px' }}>
                            Total payable amount : € {payableAmount}
                        </div>
                        <button className="list_card_view_btn" onClick={() => setSelectedPayment({ ...selectedPayment, openModal: true })}>Mark as paid {selectedPayment.ids.length}</button>
                    </div>}
                <FormControl>
                    <FormGroup>
                        <Body>
                            <Divider className='divider-gap' />
                            <List>
                                {/* <div>
                                    <FormControlLabel
                                        control={
                                            <CheckBox checked={selectedPayment.ids.length === checkAllStatusCount()} onChange={(e) => handleAllCheck()} name={'all'} />
                                        }
                                        label=""
                                    />
                                </div> */}
                                <div className="header">Payment Status</div>
                                {/* <div className="header">Payout Status</div> */}
                                <div className="header">Job No.</div>
                                <div className="header">Gateway</div>
                                <div className="header">Payment Intent</div>
                                <div className="header">Payment reference</div>

                                {/* <div className="header">Payment type</div> */}
                                <div className="header">Amount</div>

                                <div className="header">Nona earning</div>
                                <div className="header">Provider fee</div>
                                <div className="header">Refund Amount</div>
                                <div className="header">Created on</div>
                                {/* <div className="header">Paid on</div> */}
                                <div className="header"></div>
                            </List>
                            <Divider className='divider-gap' />
                            {state.payment.map((object) => ( <List key={object._id}>
                                {/* {object?.paidInfo?.status === "Unpaid" ?
                                    <FormControlLabel
                                        control={
                                            <CheckBox checked={selectedPayment.ids.includes(object._id)} onChange={(e) => handleCheck(object._id, object)} name={object._id} />
                                        }
                                        label=""
                                    /> : <div></div>} */}
                            <div className={
                                    object.status === "Captured" && object.invoiceInfo?.[0]?.paymentStatus === 307
                                      ? "list_card_status status_finalized"
                                      : object.status === "Captured"
                                        ? "list_card_status status_captured"
                                        : object.status === "Finalized"
                                          ? "list_card_status status_finalized"
                                          : object.status === "OnHold"
                                            ? "list_card_status status_inactive"
                                            : object.status === "Refunded" || object.status === "RefundByNona" 
                                              ? "list_card_status status_refunded"
                                              : object.status === "PartiallyRefund" || object.status === "PartiallyRefundByNona"
                                                ? "list_card_status status_partially_refunded"
                                                : "list_card_status status_sleeping"
                                  }
                                >
                                  {(object.status === "Captured" && object.invoiceInfo?.[0]?.paymentStatus === 307) ||
                                  object.status === "Finalized"
                                    ? "Finalized"
                                    : object.status}
                                </div>
                                {/* <div>
                                    <div className={object?.paidInfo?.status === "Unpaid" ? "list_card_status status_inactive" : "list_card_status status_active"}>{object?.paidInfo?.status}</div>
                                </div> */}
                                <div>
                                    {object.jobInfo.displayedJobId}
                                </div>
                                <div>
                                    {object.paymentGateWay}
                                </div>
                                  <div>
                                    {object.paymentIntent}
                                </div>
                                <div>
                                    {object.stripeCustomerId || object.paypalOrderId}
                                </div>
                                <div>
                                  €{" "}
                                  {["Finalized"].includes(object?.status)
                                    ? (
                                        (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.hourAdjustment?.totalAmount || 0) +
                                        (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.extraCharges || 0) +
                                        (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.tip || 0)
                                      ).toFixed(2)
                                    : ["RefundByNona", "PartiallyRefundByNona"].includes(object?.status)
                                    ? (object?.amountCaptured || 0).toFixed(2)
                                    : (object?.paymentInfo?.amount || 0).toFixed(2)}
                                </div>
                                    
                                <div>
                                 {["Refunded", "RefundByNona", "PartiallyRefundByNona"].includes(object?.status) ? (
    "€ 0.00"
                                 ) : object?.status === "Finalized" ? (
                                   "€ " + Number(object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.hourAdjustment?.toPlatform ?? 0).toFixed(2)
                                 ) : object?.status === "PartiallyRefund" ? (
                                   "€ " + Number(
                                     object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.refund?.platformFee ??
                                     object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.seekerView?.prevCustomerPenalty ??
                                     0
                                   ).toFixed(2)
                                 ) : Array.isArray(object?.invoiceInfo) && object.invoiceInfo.length !== 0 ? (
                                   "€ " + Number(object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.preAuthorizedAmount?.toPlatform ?? 0).toFixed(2)
                                 ) : (
                                   "€ ..."
                                 )}
                               </div>
                                
                                <div>
                                {["Refunded", "RefundByNona"].includes(object?.status) ? (
                                    "€ 0.00"
                                ) : object?.status === "Finalized" ? (
                                    "€ " + Number(
                                    (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.hourAdjustment?.toProvider || 0) +
                                    (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.extraCharges || 0) +
                                    (object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.tip || 0)
                                    ).toFixed(2)
                                ) : object?.status === "PartiallyRefundByNona" ? (
                                    `€ ${Number(object?.amountCaptured - object?.amountRefunded || 0).toFixed(2)}`
                                ) : object?.status === "PartiallyRefund" ? (
                                    `€ ${Number(object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.refund?.toProvider || 0).toFixed(2)}`
                                ) : Array.isArray(object?.invoiceInfo) && object.invoiceInfo.length !== 0 ? (
                                    "€ " + Number(
                                    object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.preAuthorizedAmount?.toProvider ?? 0
                                    ).toFixed(2)
                                ) : (
                                    "€ ..."
                                )}
                               </div>
                               
                                <div>
                                  {["RefundByNona", "PartiallyRefundByNona"].includes(object?.status) ? (
                                    `€ ${(object?.amountRefunded || 0).toFixed(2)}`
                                  ) : ["Refunded", "PartiallyRefund"].includes(object?.status) ? (
                                    object?.invoiceInfo?.[0]?.invoiceInfo?.billDetail?.meta?.refund?.toCustomer != null ? (
                                      `€ ${(object.invoiceInfo[0].invoiceInfo.billDetail.meta.refund.toCustomer)}`
                                    ) : (
                                      "€ ..."
                                    )
                                  ) : (
                                    "€ ..."
                                  )}
                                </div>
                                <div>
                                    {moment(object.createdAt).format("DD MMM, YYYY")}
                                </div>
                                {/* <div>
                                    {object?.paidInfo?.status === "Unpaid" ? "--" : moment(object?.paidInfo?.paidOn).format("MMM DD, YYYY")}
                                </div> */}
                                <button className="list_card_view_btn" onClick={() => { setPaymentInfo({ id: object._id, data: object, open: true }) }}>View</button>
                            </List>
                            ))}

                            <Divider className='divider-gap' />
                            {state.payment.length === 0 && <div className='no-record'><span>No Record Found</span></div>}
                        </Body>
                    </FormGroup>
                </FormControl>
            </Container>
      {state.payment.length > 0 && (
          <>
                    <Pagination count={Math.ceil(state.total / __constants.listingLimit)} color="primary" shape="rounded" onChange={(e, page) => { fetchPayments(page) }} />
                    <br />
            </>
        )}
      </>
  )
}


const MakePayment = ({ open, handleClose, paymentIds, amount, providerId, userInfo, onUpdate }) => {
    const [state, setState] = useState({ file: null, transactionId: null })
    const { setSnackBar } = useContext(mainContext);

    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const submit = async () => {
        if (!state.transactionId) {
            return callSnackBar("Please enter transactionId", "error")
        }

        const form = new FormData()
        form.append("file", state.file)
        form.append("paymentIds", paymentIds)
        form.append("transactionId", state.transactionId)
        form.append("providerId", providerId)
        const res = await markPaymentAsPaid(form)
        if (res.data.status === 200) {
            onUpdate(1)
            return callSnackBar(res.data.message, "success")
        } else {
            return callSnackBar(res.data.errors[0].message, "error")
        }

    }
    return <>
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Pay Info</DialogTitle>
            <DialogContent>
                <PaymentBox>
                    <h4><span className='sub-tx'>€</span> {amount}</h4>
                    <Divider className='divider-gap' />
                    <div className="flex-box">
                        <p>Name</p>
                        <p>{userInfo?.firstName}</p>
                    </div>
                    <div className="flex-box">
                        <p>Email</p>
                        <p>{userInfo?.email}</p>
                    </div>
                    <div className="flex-box">
                        <p>MobileNo</p>
                        <p>{userInfo?.mobileNo}</p>
                    </div>
                    <Divider className='divider-gap' />
                    <div className="flex-box">
                        <p>TransactionId/Referrence No</p>
                        <input maxLength={16} type="text" onChange={(e) => setState({ ...state, transactionId: e.target.value })} />
                    </div>
                </PaymentBox>
                <input type="file" accept='image/*' id='attachedFile' onChange={(e) => setState({ ...state, file: e.target.files[0] })} />
                <div><small>(jpeg, png, jpg, webp)</small></div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} size="small" >Cancel</Button>
                <Button variant="contained" size="small" onClick={submit}>Mark as paid</Button>
            </DialogActions>
        </Dialog>
    </>
}


const Container = styled("div")`
  .divider-gap{
        margin: 0.5rem 0;
  }
  button{
    text-transform: none;
  }
  overflow-x: auto;
  margin-bottom:10px;

`;

const Body = styled("div")`
  height: 75vh;
  width: 1450px;
  margin-bottom: 5px;
`

const List = styled("div")`
.header {
  font-family: "semi-bold";
}
  margin-top: 0.5rem;
  display: grid;
  column-gap: 3rem;
  grid-template-columns: minmax(0,3.4fr) minmax(0,1.5fr)  minmax(0,1fr) minmax(0,4.8fr) minmax(0,3fr) minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,1.2fr) minmax(0,1.2fr);
  align-items: center;
  font-size: 14px;
  min-height: 35px;
  padding: 5px 0;
`

const PaymentBox = styled("div")`
min-width:450px;
h4{
    font-size:50px;
    text-align:center;
}
.sub-tx{
    font-size:24px
}
margin-bottom:10px;
.flex-box{
    display:flex;
    justify-content:space-between;
    margin:5px 0;
    align-items:center;
}
.flex-box p{
    font-family:regular;
    font-size:14px;
}
.divider-gap{
    margin: 1rem 0;
}
input{
    border:none;
    outline:none;
    border:1px solid var(--nona-grey);
    padding:5px;
    border-radius:10px
}
`

